// extracted by mini-css-extract-plugin
module.exports = {"dotPulse":"Loader_dotPulse__2sSNX","dot-pulse":"Loader_dot-pulse__1nJI5","dot-pulse-before":"Loader_dot-pulse-before__1vmlA","dot-pulse-after":"Loader_dot-pulse-after__2DayK"};